import { getSpacingCSSValue, getSharedSpacing } from 'app/functions/grid';

/**
 * Get the CSS value of the shared spacing.
 */
export const getSharedSpacingCSSValue = () => getSpacingCSSValue(getSharedSpacing());
